/**************************************************
 * Nombre:       Seccion_Potenciales_Espacio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSPEDIDOS} from "../../Constantes";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {arrConteoColMesesAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtras";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import Dialogo_Potenciale from "../Dialogos/Dialogo_Potenciale";
import {useParams} from "react-router";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";


const Seccion_Potenciales_Espacio = () => {
    const params = useParams();
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [wheres, setWheres] = useState([where('idEspacio', '==', 'none')])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'potencialesEspacios', wheres: wheres})
    const [numPedidos, setNumPedidos] = useState([])
    const [locales, setLocales] = useState([])
    const [espacio, setEspacio] = useState({})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Potenciale,
        titulo: 'Detalles la potencial',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    const obtenerDatos = async (id) => {

        let dox = await obtenerDoc('espacios', id)
        setEspacio(dox.data)

        let w = [where('idEspacio', '==', id)]
        let doxPedidos = await arrConteoColMesesAtras({coleccion: 'potencialesEspacios', mesesAtras: 6, wheres: w})
        setNumPedidos(doxPedidos)

        let locales_ = await arrConteoColPropiedadEstados({
            coleccion: 'potencialesEspacios',
            propiedad: 'estado',
            arrEstados: ESTADOSPEDIDOS.map((it) => it.nombre).reverse(),
            wheres: w
        })

        setLocales(locales_)


    }


    useEffect(() => {

        if (params && params.id) {

            setWheres([where('idEspacio', '==', params.id)])
            obtenerDatos(params.id).then((data) => {
            })


        }


    }, [params]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Personas Inscritas'}
                        subtitulo={espacio.nombreResaltado + ' ' + espacio.nombre}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: numPedidos.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={numPedidos.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Segun'}
                        subtitulo={'estado'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'locales',
                                data: locales.map((e) => e.cantidad)
                            }]
                        }

                        labels={ESTADOSPEDIDOS.map((it) => it.nombre.substring(0, 3))}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de personas'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Potenciales_Espacio

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]


const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Pais',
        direccion: 'left',
        propiedad: 'celular',
        titulo: 'pais',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Esacio',
        direccion: 'left',
        propiedad: 'espacio',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]